<template>
  <div class="group-grid py-6 items-center text-right
              text-sm text-text-secondary font-medium">
    <AssetGroupIcon class="md:w-16 md:h-16" :asset-type="assetGroup.properties.type"/>
    <div class="text-left">{{ assetName }}</div>
    <div>{{ assetGroup.properties.share }} %</div>
    <div>{{ sumDisplayed }}</div>
    <div>{{ assetGroup.properties.profitability }} %</div>
    <div>
      <ValueWIndicator :value="assetGroup.properties.profit_absolute_day_base"
                       :percent="assetGroup.properties.profit_percent_day"/>
    </div>
    <div>
      <ValueWIndicator :value="assetGroup.properties.profit_absolute_month_base"
                       :percent="assetGroup.properties.profit_percent_month"/>
    </div>
    <div>
      <ValueWIndicator :value="assetGroup.properties.profit_absolute_base"
                       :percent="assetGroup.properties.profit_percent"/>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import ValueWIndicator
  from "@/components/common/Investments/ValueWIndicator";
import AssetGroupIcon from "@/components/common/Investments/AssetGroupIcon";

export default {
  name: "PortfolioStructureItem",
  components: {AssetGroupIcon, ValueWIndicator},
  props: {
    assetGroup: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState('investments/portfolios', ['current_portfolio']),
    ...mapGetters('cabinet/currencies', ['formattedCurrencyValue']),
    assetName() {
      switch (this.assetGroup.properties.type) {
        case 1:
          return 'Акции'
        case 2:
          return 'Облигации'
        case 3:
          return 'Фонд'
        case 4:
          return 'Валюта'
        case 5:
          return 'Другое'
      }
    },
    sumDisplayed() {
      return this.formattedCurrencyValue(+this.assetGroup.properties.sum_base)
    }
  }
}
</script>